import WidgetModule from "@eisinc/Overrides/Widgets/ProductDetails/ProductDetailsCustomerPartNumber";

export * from "@eisinc/Overrides/Widgets/ProductDetails/ProductDetailsCustomerPartNumber";

export default WidgetModule;
